import React, { useState, useEffect } from 'react'
import Classes from './Orders.module.css'
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Orders() {
    const initialOrders = [
        { "ID": 12345, "Title": "SEO", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Submitted" },
        { "ID": 12345, "Title": "SEO", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Working" },
        { "ID": 12345, "Title": "Website Audit", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Pending" },
        { "ID": 12345, "Title": "Website Audit", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Completed" },
        { "ID": 12345, "Title": "UI/UX", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Canceled" },
        { "ID": 12345, "Title": "UI/UX", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Working" },
        { "ID": 12345, "Title": "Copywriting", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Submitted" },
        { "ID": 12345, "Title": "Copywriting", "Created": "March 3, 2025", "Amount": "$400.00", "Status": "Submitted" }
    ]

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(initialOrders.length / itemsPerPage);
    const currentItems = initialOrders.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialOrders.length);
    const totalItems = initialOrders.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-order');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3>Orders</h3>
                    <h5>Manage your orders.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <div className={Classes.table} >
                <div className={Classes.tableWrapper}>

                    <div className={Classes.tableHeader}>
                        <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                            <h5 className="truncate">ID</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                            <h5>Title</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                            <h5>Created</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                            <h5>Amount</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerDisable}`}>
                            <h5>Status</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerActions}`}>
                            {/* actions */}
                        </div>
                    </div>

                    <div className={Classes.tableBody}>
                        {loading ? (
                            <SkeletonLoading
                                length={itemsPerPage}
                                height={isMobile ? '6rem' : '2.8rem'}
                                width="100%"
                                br="6px"
                            />
                        ) : currentItems && currentItems.length > 0 ? (
                            currentItems.map((cust, idx) => (
                                <TableRow
                                    key={cust._id}
                                    value={cust}
                                    index={idx}
                                />
                            ))
                        ) : (
                            <div>No customer found.</div>
                        )}
                    </div>

                    <div className={Classes.pagFooter}>
                        <h5 style={{ height: '1.2rem' }}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                                : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                            }
                        </h5>
                        <Stack spacing={2} className={Classes.pagination}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                                : <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    shape="rounded"
                                />
                            }
                        </Stack>
                    </div>
                </div>
            </div>
        </div>
    )
}
